var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('LineChartComponent',{staticStyle:{"height":"250px"},attrs:{"chartID":'ChartPerManagers',"chartData":_vm.chartData,"legendHandler":_vm.action_Legend,"legendsMaxLength":30}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }